const layoutTranslation = {
  'header.language': 'Languages',
  'header.welcome': 'Welcome',
  'header.settings': 'Profile',
  'header.signOut': 'Sign Out',

  'menu.dashboard.divider': 'Dashboard',
  'menu.dashboard': 'Dashboard',
  'menu.signOut': 'Sign Out',
  'menu.settings.divider': 'Account Settings',
  'menu.settings': 'Profile',

  'footer.text': 'All rights reserved.',
};

export default layoutTranslation;
